import type { RouteLocationRaw } from "vue-router";

enum MenuType {
  GROUP = "group",
  LINK = "link",
}

interface MenuEntity {
  type: MenuType;
  label: string;
  icon?: string;
  highlight?: {
    value?: number;
    icon?: string;
    color?: "primary" | "warning" | "info" | "success" | "danger";
  };
  route?: RouteLocationRaw;
  index?: string;
  /** When true, this item will be active if the current route starts with the index */
  matchChildRoutes?: boolean;
  children?: MenuEntity[];
}

export { MenuType };
export type { MenuEntity };
